
import { v4 as uuidv4 } from "uuid";
import { FeatureUserRating } from "@models";
import {
  Potence,
  // PotenceUpgradable,
  UpgradableNumber,
} from "@dndModels";
import { AbilityScoreExpandedType, AreaType, AttackType, DamageType, EffectType, isDamageType, TargetType } from "@dndModels/Types";

export class EffectBase {
  true_id = "";
  type: EffectType = "None"; // damage type or 'Control', 'Utility', 'Healing', 'Max HP', or 'Temp HP'
  damage_types: DamageType[] = [];
  utility_detail = "";
  potence_type = "None"; // Character, Class, Slot (Level), or None
  potence_class = "";
  // add_modifier: string = "false"; // boolean or condition
  attack_type: AttackType = "None"; // melee, ranged, melee spell, ranged spell, bonus, save, or none
  saving_throw_ability_score: AbilityScoreExpandedType | "" = "";
  half_on_success = false;
  // potences: Potence[] = []; 
  bonus: UpgradableNumber; // TODO: Remove me.
  // conditions_applied: string[] = [];
  refresh_only = false;
  selectable_type = "Damage Type";
  selectable_key = "";
  rollable_table_id = "New";
  name = "";
  description = "";
  target_int: TargetInterface = new TargetInterface();
  choose_card = false;

  constructor(obj?: any, log_it = false) {
    // if (log_it) {
    //   debugger;
    // }
    this.bonus = new UpgradableNumber();
    this.true_id = obj && obj.true_id ? obj.true_id : uuidv4().toString();
    if (obj) {
      this.type = obj.type ? obj.type : "Utility";
      if (this.type === "None") {
        this.type = "Utility";
      }
      this.damage_types = obj.damage_types ? obj.damage_types : [];
      if (this.damage_types.length === 0 && isDamageType(this.type)) {
        this.type = "Damage";
        this.damage_types.push(obj.type);
      }
      this.utility_detail = obj.utility_detail ? obj.utility_detail : "";
      this.name = obj.name ? obj.name : "";
      this.description = obj.description ? obj.description : "";
      this.selectable_type = obj.selectable_type ? obj.selectable_type : "Damage Type";
      this.rollable_table_id = obj.rollable_table_id ? obj.rollable_table_id : "New";
      this.selectable_key = obj.selectable_key ? obj.selectable_key : "";
      this.potence_type = obj.potence_type ? obj.potence_type : "None";
      if (this.potence_type === "Class") {
        this.potence_type = "Source";
      }
      this.potence_class = obj.potence_class ? obj.potence_class : "";
      // this.add_modifier = obj.add_modifier ? obj.add_modifier : "false";
      this.attack_type = obj.attack_type ? obj.attack_type : "None";
      this.saving_throw_ability_score = obj.saving_throw_ability_score ? obj.saving_throw_ability_score : "";
      this.half_on_success = obj.half_on_success ? obj.half_on_success : false;
      // this.potences = [];
      // if (obj.potences) {
      //   if (obj.potences.length) {
      //     for (const p of obj.potences) {
      //       this.potences.push(new Potence(p, log_it));
      //     }
      //   } else {
      //     // It's an object from before I changed the structure.
      //     Object.keys(obj.potences).forEach((key: string) => {
      //       const potence_obj = obj.potences[key];
      //       const potence = new Potence();
      //       potence.level = +key;
      //       if (potence_obj.rolls) {
      //         potence.rolls = potence_obj.rolls.clone();
      //       } else if (potence_obj.dice_count && potence.rolls.count.isBasic() && potence.rolls.count.base === 0) {
      //         potence.rolls.count.base = +potence_obj.dice_count;
      //       }
      //       if (potence_obj.dice_size && potence.rolls.size.isBasic() && potence.rolls.size.base === 0) {
      //         potence.rolls.size.base = +potence_obj.dice_size;
      //       }
      //       this.potences.push(potence);
      //     });
      //   }
      // }
      if (log_it) {
        debugger;
      }
      if (obj.bonus) {
        if (obj.bonus.base !== undefined) {
          this.bonus = new UpgradableNumber(obj.bonus);
        }
      }
      // if (this.type === "Self Condition") {
      //   if (this.potences.length === 0 && obj.conditions_applied) {
      //     const potence = new Potence();
      //     potence.conditions_applied = obj.conditions_applied;
      //     this.potences.push(potence);
      //   }
      // }
      
      // if (this.potences.length === 0 && obj.create_resource_type && obj.create_resource_type !== "None") {
      //   const potence = new Potence();
      //   potence.create_resource.resource_type = obj.create_resource_type ? obj.create_resource_type : "None";
      //   potence.create_resource.level = obj.create_resource_level ? `${obj.create_resource_level}` : "1";
      //   if (obj.create_resource_amount) {
      //     if (obj.create_resource_amount.base !== undefined) {
      //       potence.create_resource.level = `${obj.create_resource_amount.base}`;
      //     } else {
      //       potence.create_resource.level = `${obj.create_resource_amount}`;
      //     }
      //   }
      //   this.potences.push(potence);
      // }
      this.refresh_only = obj.refresh_only ? obj.refresh_only : false;
      this.target_int = obj.target_int ? new TargetInterface(obj.target_int) : new TargetInterface();
      this.choose_card = obj.choose_card ? obj.choose_card : false;
      if (this.type === "Summon" && this.attack_type !== "None") {
        this.attack_type = "None";
      }
      if (this.type === "Utility" || this.type === "Control") {
        if (this.utility_detail.includes("Teleport")) {
          this.type = "Teleport";
        }
      }
    }
    if (log_it) {
      console.log(this);
      console.log([...this.damage_types]);
    }
  }
  
  get use_attack(): boolean {
    if (!["None",
      "Control",
      "Summon",
      "Transform",
      "Create Resource",
      "Utility",
      "Healing",
      "Max HP",
      "Temp HP",
      "Bonus Roll",
      "Self Condition"].includes(this.type) && 
      !["None","undefined","Save"].includes(this.attack_type)) {
      return true;
    } else if (this.type === "Selectable Key" && 
      this.selectable_type === "Damage Type" && 
      !["None","undefined","Save"].includes(this.attack_type)) {
      return true;
    }
    return false;
  }

  get range_string(): string {
    // let range_string = "";
    // const target_int = this.target_int;
    // const range = target_int.range.base;
    // switch (target_int.target_type) {
    //   case "Self": return "Self";
    //   case "X Targets": 
    //     if (range === -1) {
    //       return "";
    //     }
    //     const range2 = target_int.range2;
    //     return range > 0 && range2 > 0 ? `${range} ft./${range2} ft.` : (range > 0 ? `${range} ft.` : (range2 > 0 ? `${range2} ft.` : "Touch"));
    //   case "Area": 
    //     if (range > 0) {
    //       range_string = `${range} ft./`;
    //     }
    //     range_string += `${target_int.area} ft. ${target_int.area_type}`;
    //   break;
    // }
    return this.get_range_string();
  }

  // get condition_damage_types() {
  //   return this.potences.flatMap(o => o.condition_damage_types);
  // }

  // get the_damage_types() {
  //   return [...this.damage_types,...this.condition_damage_types];
  // }

  get_range_string(log_it = false): string {
    if (log_it) {
      debugger;
    }
    let range_string = "";
    const target_int = this.target_int;
    const range = target_int.range.base;
    switch (target_int.target_type) {
      case "Self": return "Self";
      case "X Targets": 
        if (range === -1) {
          return "";
        }
        const range2 = target_int.range2.base;
        return range > 0 && range2 > 0 ? `${range} ft./${range2} ft.` : (range > 0 ? `${range} ft.` : (range2 > 0 ? `${range2} ft.` : "Touch"));
      case "Area": 
        if (range > 0) {
          range_string = `${range} ft./`;
        }
        range_string += `${target_int.area.base} ft. ${target_int.area_type}`;
      break;
    }
    return range_string;
  }

  toDBObj(): any {
    return {
      type: this.type,
      damage_types: this.damage_types,
      utility_detail: this.utility_detail,
      name: this.name,
      description: this.description,
      potence_type: this.potence_type,
      potence_class: this.potence_class,
      // add_modifier: this.add_modifier,
      attack_type: this.attack_type,
      saving_throw_ability_score: this.saving_throw_ability_score,
      half_on_success: this.half_on_success,
      // potences: this.potences.map(o => o.toDBObj()),
      bonus: this.bonus.toDBObj(),
      // conditions_applied: this.conditions_applied,
      refresh_only: this.refresh_only,
      selectable_type: this.selectable_type,
      selectable_key: this.selectable_key,
      rollable_table_id: this.rollable_table_id,
      target_int: this.target_int.toDBObj(),
      choose_card: this.choose_card
    };
  }

  clone(drop_ids = false): EffectBase {
    const new_obj = new EffectBase();
    new_obj.copy(this, drop_ids);
    return new_obj;
  }

  copy(copyMe: EffectBase, drop_ids = false): void {
    if (!drop_ids) {
      this.true_id = copyMe.true_id;
    }
    this.type = copyMe.type;
    this.damage_types = [...copyMe.damage_types];
    this.utility_detail = copyMe.utility_detail;
    this.name = copyMe.name;
    this.description = copyMe.description;
    this.selectable_type = copyMe.selectable_type;
    this.selectable_key = copyMe.selectable_key;
    this.rollable_table_id = copyMe.rollable_table_id;
    this.potence_type = copyMe.potence_type;
    this.potence_class = copyMe.potence_class;
    // this.add_modifier = copyMe.add_modifier;
    this.attack_type = copyMe.attack_type;
    this.saving_throw_ability_score = copyMe.saving_throw_ability_score;
    this.half_on_success = copyMe.half_on_success;
    // this.potences = copyMe.potences.map(o => o.clone(drop_ids));
    this.bonus = copyMe.bonus.clone();
    // this.conditions_applied = [...copyMe.conditions_applied];
    this.refresh_only = copyMe.refresh_only;
    this.target_int = copyMe.target_int.clone();
    this.choose_card = copyMe.choose_card;
  }

  connectUserRatings(userRatings: FeatureUserRating[]) {
    // this.potences.forEach(potence => {
    //   potence.connectUserRatings(userRatings);
    // });
  }
}

export class AbilityEffect extends EffectBase {
  potences: Potence[] = []; 

  constructor(obj?: any, log_it = false) {
    // if (log_it) {
    //   debugger;
    // }
    super(obj, log_it);
    if (obj) {
      this.potences = [];
      if (obj.potences) {
        if (obj.potences.length) {
          for (const p of obj.potences) {
            this.potences.push(new Potence(p, log_it));
          }
        } else {
          // It's an object from before I changed the structure.
          Object.keys(obj.potences).forEach((key: string) => {
            const potence_obj = obj.potences[key];
            const potence = new Potence();
            potence.level = +key;
            if (potence_obj.rolls) {
              potence.rolls = potence_obj.rolls.clone();
            } else if (potence_obj.dice_count && potence.rolls.count.isBasic() && potence.rolls.count.base === 0) {
              potence.rolls.count.base = +potence_obj.dice_count;
            }
            if (potence_obj.dice_size && potence.rolls.size.isBasic() && potence.rolls.size.base === 0) {
              potence.rolls.size.base = +potence_obj.dice_size;
            }
            this.potences.push(potence);
          });
        }
      }
      if (log_it) {
        debugger;
      }
      if (obj.bonus) {
        if (obj.bonus.base !== undefined) {
          this.bonus = new UpgradableNumber(obj.bonus);
        }
      }
      if (this.type === "Self Condition") {
        if (this.potences.length === 0 && obj.conditions_applied) {
          const potence = new Potence();
          potence.conditions_applied = obj.conditions_applied;
          this.potences.push(potence);
        }
      }
      
      if (this.potences.length === 0 && obj.create_resource_type && obj.create_resource_type !== "None") {
        const potence = new Potence();
        potence.create_resource.resource_type = obj.create_resource_type ? obj.create_resource_type : "None";
        potence.create_resource.level = obj.create_resource_level ? `${obj.create_resource_level}` : "1";
        if (obj.create_resource_amount) {
          if (obj.create_resource_amount.base !== undefined) {
            potence.create_resource.level = `${obj.create_resource_amount.base}`;
          } else {
            potence.create_resource.level = `${obj.create_resource_amount}`;
          }
        }
        this.potences.push(potence);
      }
      if (isDamageType(this.type)) {
        this.damage_types = [this.type]
        this.type = "Damage";
      }
    }
    if (log_it) {
      console.log(this);
      console.log([...this.damage_types]);
    }
  }

  get condition_damage_types() {
    return this.potences.flatMap(o => o.condition_damage_types);
  }

  get the_damage_types() {
    return [...this.damage_types,...this.condition_damage_types];
  }

  get_range_string(log_it = false): string {
    if (log_it) {
      debugger;
    }
    let range_string = "";
    const target_int = this.target_int;
    const range = target_int.range.base;
    switch (target_int.target_type) {
      case "Self": return "Self";
      case "X Targets": 
        if (range === -1) {
          return "";
        }
        const range2 = target_int.range2.base;
        return range > 0 && range2 > 0 ? `${range} ft./${range2} ft.` : (range > 0 ? `${range} ft.` : (range2 > 0 ? `${range2} ft.` : "Touch"));
      case "Area": 
        if (range > 0) {
          range_string = `${range} ft./`;
        }
        range_string += `${target_int.area.base} ft. ${target_int.area_type}`;
      break;
    }
    return range_string;
  }

  toDBObj(): any {
    return {
      ...super.toDBObj(),
      potences: this.potences.map(o => o.toDBObj()),
    };
  }

  clone(drop_ids = false): AbilityEffect {
    const new_obj = new AbilityEffect();
    new_obj.copy(this, drop_ids);
    return new_obj;
  }

  copy(copyMe: AbilityEffect, drop_ids = false): void {
    super.copy(copyMe, drop_ids);
    this.potences = copyMe.potences.map(o => o.clone(drop_ids));
  }

  connectUserRatings(userRatings: FeatureUserRating[]) {
    this.potences.forEach(potence => {
      potence.connectUserRatings(userRatings);
    });
  }
}

// export class AbilityEffectUpgradable extends EffectBase {
//   potences: PotenceUpgradable[] = []; 

//   constructor(obj?: any, log_it: boolean = false) {
//     // if (log_it) {
//     //   debugger;
//     // }
//     super(obj, log_it);
//     if (obj) {
//       this.potences = [];
//       if (obj.potences) {
//         if (obj.potences.length) {
//           for (const p of obj.potences) {
//             this.potences.push(new PotenceUpgradable(p, log_it));
//           }
//         } else {
//           // It's an object from before I changed the structure.
//           Object.keys(obj.potences).forEach((key: string) => {
//             const potence_obj = obj.potences[key];
//             const potence = new PotenceUpgradable();
//             potence.level = +key;
//             if (potence_obj.rolls) {
//               potence.rolls = potence_obj.rolls.clone();
//             } else if (potence_obj.dice_count && potence.rolls.count.isBasic() && potence.rolls.count.base === 0) {
//               potence.rolls.count.base = +potence_obj.dice_count;
//             }
//             if (potence_obj.dice_size && potence.rolls.size.isBasic() && potence.rolls.size.base === 0) {
//               potence.rolls.size.base = +potence_obj.dice_size;
//             }
//             this.potences.push(potence);
//           });
//         }
//       }
//       if (log_it) {
//         debugger;
//       }
//       if (obj.bonus) {
//         if (obj.bonus.base !== undefined) {
//           this.bonus = new UpgradableNumber(obj.bonus);
//         }
//       }
//       if (this.type === "Self Condition") {
//         if (this.potences.length === 0 && obj.conditions_applied) {
//           const potence = new PotenceUpgradable();
//           potence.conditions_applied = obj.conditions_applied;
//           this.potences.push(potence);
//         }
//       }
      
//       if (this.potences.length === 0 && obj.create_resource_type && obj.create_resource_type !== "None") {
//         const potence = new PotenceUpgradable();
//         // potence.create_resource.resource_type = obj.create_resource_type ? obj.create_resource_type : "None";
//         // potence.create_resource.level = obj.create_resource_level ? `${obj.create_resource_level}` : "1";
//         // if (obj.create_resource_amount) {
//         //   if (obj.create_resource_amount.base !== undefined) {
//         //     potence.create_resource.level = `${obj.create_resource_amount.base}`;
//         //   } else {
//         //     potence.create_resource.level = `${obj.create_resource_amount}`;
//         //   }
//         // }
//         this.potences.push(potence);
//       }
//     }
//     if (log_it) {
//       console.log(this);
//       console.log([...this.damage_types]);
//     }
//   }

//   get condition_damage_types() {
//     return this.potences.flatMap(o => o.condition_damage_types);
//   }

//   get the_damage_types() {
//     return [...this.damage_types,...this.condition_damage_types];
//   }

//   get_range_string(log_it: boolean = false): string {
//     if (log_it) {
//       debugger;
//     }
//     let range_string = "";
//     const target_int = this.target_int;
//     const range = target_int.range.base;
//     switch (target_int.target_type) {
//       case "Self": return "Self";
//       case "X Targets": 
//         if (range === -1) {
//           return "";
//         }
//         const range2 = target_int.range2.base;
//         return range > 0 && range2 > 0 ? `${range} ft./${range2} ft.` : (range > 0 ? `${range} ft.` : (range2 > 0 ? `${range2} ft.` : "Touch"));
//       case "Area": 
//         if (range > 0) {
//           range_string = `${range} ft./`;
//         }
//         range_string += `${target_int.area.base} ft. ${target_int.area_type}`;
//       break;
//     }
//     return range_string;
//   }

//   toDBObj(): any {
//     return {
//       ...super.toDBObj(),
//       potences: this.potences.map(o => o.toDBObj()),
//     };
//   }

//   clone(drop_ids: boolean = false): AbilityEffectUpgradable {
//     const new_obj = new AbilityEffectUpgradable();
//     new_obj.copy(this, drop_ids);
//     return new_obj;
//   }

//   copy(copyMe: AbilityEffectUpgradable, drop_ids: boolean = false): void {
//     super.copy(copyMe, drop_ids);
//     this.potences = copyMe.potences.map(o => o.clone(drop_ids));
//   }
// }

// export class AbilityEffectUpgradable {
//   true_id: string = "";
//   type: EffectType = "None"; // damage type or 'Control', 'Utility', 'Healing', 'Max HP', or 'Temp HP'
//   damage_types: DamageType[] = [];
//   utility_detail: string = "";
//   potence_type: string = "Slot"; // Character, Class, or Slot (Level)
//   potence_class: string = "";
//   // add_modifier: string = "false"; // boolean or condition
//   attack_type: AttackType = "Ranged Spell"; // melee, ranged, melee spell, ranged spell, bonus, save, or none
//   saving_throw_ability_score: string = "";
//   potences: PotenceUpgradable[] = []; 
//   bonus: UpgradableNumber = new UpgradableNumber();
//   conditions_applied: string[] = [];
//   selectable_type: string = "Damage Type";
//   selectable_key: string = "";

//   constructor(obj?: any) {
//     this.true_id = obj && obj.true_id ? obj.true_id : uuidv4().toString();
//     if (obj) {
//       this.type = obj.type ? obj.type : "None";
//       this.damage_types = obj.damage_types ? obj.damage_types : [];
//       if (this.damage_types.length === 0 && isDamageType(this.type)) {
//         this.type = "Damage";
//         this.damage_types.push(obj.type);
//       }
//       this.utility_detail = obj.utility_detail ? obj.utility_detail : "";
//       this.selectable_type = obj.selectable_type ? obj.selectable_type : "Damage Type";
//       this.selectable_key = obj.selectable_key ? obj.selectable_key : "";
//       this.potence_type = obj.potence_type ? obj.potence_type : "Slot";
//       this.potence_class = obj.potence_class ? obj.potence_class : "";
//       // this.add_modifier = obj.add_modifier ? obj.add_modifier : "false";
//       this.attack_type = obj.attack_type ? obj.attack_type : "Ranged Spell";
//       this.saving_throw_ability_score = obj.saving_throw_ability_score ? obj.saving_throw_ability_score : "";
//       this.potences = [];
//       if (obj.potences && obj.potences.length) {
//         obj.potences.forEach((p: any) => {
//           this.potences.push(new PotenceUpgradable(p));
//         });
//       }
//       this.bonus = new UpgradableNumber();
//       if (obj.bonus && obj.bonus.base !== undefined) {
//         this.bonus = new UpgradableNumber(obj.bonus);
//       }
//       // this.conditions_applied = obj.conditions_applied ? obj.conditions_applied : [];
//     }
//   }

//   toDBObj(): any {
//     const potences: any[] = [];
//     this.potences.forEach(p => {
//       potences.push(p.toDBObj());
//     });
//     return {
//       type: this.type,
//       damage_types: this.damage_types,
//       utility_detail: this.utility_detail,
//       potence_type: this.potence_type,
//       potence_class: this.potence_class,
//       // add_modifier: this.add_modifier,
//       attack_type: this.attack_type,
//       saving_throw_ability_score: this.saving_throw_ability_score,
//       potences,
//       bonus: this.bonus.toDBObj(),
//       // conditions_applied: this.conditions_applied,
//       selectable_type: this.selectable_type,
//       selectable_key: this.selectable_key
//     };
//   }

//   clone(drop_ids: boolean = false): AbilityEffectUpgradable {
//     const new_obj = new AbilityEffectUpgradable();
//     new_obj.copy(this, drop_ids);
//     return new_obj;
//   }

//   copy(copyMe: AbilityEffectUpgradable, drop_ids: boolean = false): void {
//     if (!drop_ids) {
//       this.true_id = copyMe.true_id;
//     }
//     this.type = copyMe.type;
//     this.damage_types = [...copyMe.damage_types];
//     this.utility_detail = copyMe.utility_detail;
//     this.selectable_type = copyMe.selectable_type;
//     this.selectable_key = copyMe.selectable_key;
//     this.potence_type = copyMe.potence_type;
//     this.potence_class = copyMe.potence_class;
//     // this.add_modifier = copyMe.add_modifier;
//     this.attack_type = copyMe.attack_type;
//     this.saving_throw_ability_score = copyMe.saving_throw_ability_score;
//     this.potences = [];
//     copyMe.potences.forEach(p => {
//       this.potences.push(p.clone(drop_ids));
//     });
//     this.bonus = copyMe.bonus.clone();
//     // this.conditions_applied = [...copyMe.conditions_applied];
//   }

//   copyAbilityEffect(copyMe: AbilityEffect): void {
//     this.type = copyMe.type;
//     this.damage_types = [...copyMe.damage_types];
//     this.utility_detail = copyMe.utility_detail;
//     this.selectable_type = copyMe.selectable_type;
//     this.selectable_key = copyMe.selectable_key;
//     this.potence_type = copyMe.potence_type;
//     this.potence_class = copyMe.potence_class;
//     // this.add_modifier = copyMe.add_modifier;
//     this.attack_type = copyMe.attack_type;
//     this.saving_throw_ability_score = copyMe.saving_throw_ability_score;
//     this.potences = [];
//     copyMe.potences.forEach(p => {
//       const new_potence = new PotenceUpgradable();
//       new_potence.copyPotence(p);
//       this.potences.push(new_potence);
//     });
//     this.bonus = copyMe.bonus.clone();
//     // this.conditions_applied = [...copyMe.conditions_applied];
//   }

//   convert_to_ability_effect(char: Character, class_id: string, base_slot_level: number, slot_level: number): AbilityEffect {
//     const ability_effect = new AbilityEffect();
//     ability_effect.utility_detail = this.utility_detail;
//     // ability_effect.add_modifier = this.add_modifier;
//     ability_effect.attack_type = this.attack_type;
//     // ability_effect.conditions_applied = this.conditions_applied;
//     ability_effect.bonus = this.bonus.clone();
//     // const bonus = this.bonus.value({ char, source_id: class_id, base_slot_level, slot_level });
//     ability_effect.potence_type = this.potence_type;
//     ability_effect.potence_class = this.potence_class;
//     ability_effect.potences = [];
//     this.potences.forEach(p => {
//       const potence = new Potence();
//       potence.conditions_applied = [...p.conditions_applied];
//       potence.extra = p.extra;
//       potence.level = p.level;
//       potence.rolls = p.rolls.clone();
//       // potence.rolls = new RollPlus();
//       // potence.rolls.ability_score = p.rolls.ability_score;
//       // potence.rolls.count = +p.rolls.count.value({ char, source_id: class_id, base_slot_level, slot_level });
//       // potence.rolls.flat = +p.rolls.flat.value({ char, source_id: class_id, base_slot_level, slot_level }) + bonus;
//       // potence.rolls.size = +p.rolls.size.value({ char, source_id: class_id, base_slot_level, slot_level });
//       // if (potence.rolls.count > 0) {
//       //   if (potence.rolls.flat > 0) {
//       //     potence.rolls.as_string = `${potence.rolls.count}d${potence.rolls.size}+${potence.rolls.flat}`;
//       //   } else {
//       //     potence.rolls.as_string = `${potence.rolls.count}d${potence.rolls.size}`;
//       //   }
//       // } else if (potence.rolls.flat > 0) {
//       //   potence.rolls.as_string = `${potence.rolls.flat}`;
//       // }
//       // potence.rolls.type = p.rolls.type;
//       // potence.rolls.true_id = p.rolls.true_id;
//       potence.true_id = p.true_id;
//       ability_effect.potences.push(potence);
//     });
//     ability_effect.type = this.type;
//     ability_effect.damage_types = [...this.damage_types];
//     ability_effect.selectable_type = this.selectable_type;
//     ability_effect.selectable_key = this.selectable_key;
//     return ability_effect;
//   }
  
//   get use_attack(): boolean {
//     if (!["None",
//       "Control",
//       "Summon",
//       "Transform",
//       "Create Resource",
//       "Utility",
//       "Healing",
//       "Max HP",
//       "Temp HP",
//       "Bonus Roll",
//       "Self Condition"].includes(this.type) && 
//       !["None","undefined","Save"].includes(this.attack_type)) {
//       return true;
//     } else if (this.type === "Selectable Key" && 
//       this.selectable_type === "Damage Type" && 
//       !["None","undefined","Save"].includes(this.attack_type)) {
//       return true;
//     }
//     return false;
//   }
// }

export class TargetInterface {
  range: UpgradableNumber = new UpgradableNumber(); // How far from self you can trigger the effect, or how close to self the target(s) need to be
  range2: UpgradableNumber = new UpgradableNumber(); // Same, but DISADV on attacks
  target_type: TargetType = "X Targets";
  area: UpgradableNumber = new UpgradableNumber(); // How big the area of effect
  area2: UpgradableNumber = new UpgradableNumber(); // For some area types it specifies a second number for it.  For Line, this is the thickness, and for Cylinder, this is the height
  area3: UpgradableNumber = new UpgradableNumber(); // This is specifically for Wall, which has length, height, and thickness
  area_type: AreaType = "None";
  
  constructor(obj?: any, log_it = false) {
    if (obj) {
      this.range = obj.range ? new UpgradableNumber(obj.range) : new UpgradableNumber();
      this.range2 = obj.range2 ? new UpgradableNumber(obj.range2) : new UpgradableNumber();
      this.target_type = obj.target_type ? obj.target_type : "X Targets";
      this.area = obj.area ? new UpgradableNumber(obj.area) : new UpgradableNumber();
      this.area2 = obj.area2 ? new UpgradableNumber(obj.area2) : new UpgradableNumber();
      this.area3 = obj.area3 ? new UpgradableNumber(obj.area3) : new UpgradableNumber();
      this.area_type = obj.area_type ? obj.area_type : "None";
    }
  }

  toDBObj(): any {
    return {
      range: this.range.toDBObj(),
      range2: this.range2.toDBObj(),
      target_type: this.target_type,
      area: this.area.toDBObj(),
      area2: this.area2.toDBObj(),
      area3: this.area3.toDBObj(),
      area_type: this.area_type
    };
  }

  clone(): TargetInterface {
    const new_obj = new TargetInterface();
    new_obj.copy(this);
    return new_obj;
  }

  copy(copyMe: TargetInterface): void {
    this.range = copyMe.range.clone();
    this.range2 = copyMe.range2.clone();
    this.target_type = copyMe.target_type;
    this.area = copyMe.area.clone();
    this.area2 = copyMe.area2.clone();
    this.area3 = copyMe.area3.clone();
    this.area_type = copyMe.area_type;
  }
}